module.exports = __webpack_public_path__ + "img/time4.457a70bb.png";